var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon24",
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    viewBox: "0 0 1 1",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.63 0.17c-0.03,0 -0.04,-0.02 -0.04,-0.04 0,-0.03 0.01,-0.04 0.04,-0.04l0.16 0c0.02,0 0.04,0 0.05,0.01l0 0c0.02,0 0.03,0.01 0.04,0.02 0.01,0.01 0.02,0.03 0.03,0.04l0 0.01c0.01,0.01 0.01,0.02 0.01,0.04l0 0.58c0,0.02 0,0.04 -0.01,0.05 -0.01,0.02 -0.02,0.03 -0.03,0.04 -0.01,0.01 -0.02,0.02 -0.04,0.03l0 0c-0.02,0.01 -0.03,0.01 -0.05,0.01l-0.16 0c-0.03,0 -0.04,-0.02 -0.04,-0.04 0,-0.03 0.01,-0.04 0.04,-0.04l0.16 0c0.01,0 0.01,-0.01 0.02,-0.01l0 0c0,0 0.01,0 0.01,-0.01 0.01,0 0.01,-0.01 0.01,-0.01 0,-0.01 0.01,-0.01 0.01,-0.02l0 -0.58c0,0 -0.01,-0.01 -0.01,-0.01l0 -0.01c0,0 0,-0.01 -0.01,-0.01 0,0 0,-0.01 -0.01,-0.01l0 0c-0.01,0 -0.01,0 -0.02,0l-0.16 0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.45 0.74c-0.02,0.02 -0.04,0.02 -0.06,0 -0.02,-0.02 -0.02,-0.04 0,-0.06l0.18 -0.18 -0.18 -0.18c-0.02,-0.01 -0.02,-0.04 0,-0.06 0.02,-0.01 0.04,-0.01 0.06,0l0.21 0.21c0.01,0.02 0.01,0.05 0,0.06l-0.21 0.21z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.63 0.46c0.02,0 0.04,0.02 0.04,0.04 0,0.03 -0.02,0.04 -0.04,0.04l-0.5 0c-0.03,0 -0.04,-0.01 -0.04,-0.04 0,-0.02 0.01,-0.04 0.04,-0.04l0.5 0z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/Logout.a4e64280135dd1842af5b39b8f568571.svg";
export { ForwardRef as ReactComponent };